"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socketSend = exports.socketMessage = exports.socketEmitter = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxSaga = require("redux-saga");
var _Types = require("../../../../Types");
var _socketConfig = require("./socket-config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const socketSend = _ref => {
  let {
    method,
    socket,
    payload
  } = _ref;
  try {
    if (!socket) throw new Error('Socket is not exist');
    if (socket.readyState !== _socketConfig.readyStates.OPEN) {
      throw new Error("Socket is not OPEN, status: ".concat(_socketConfig.readyStateText[socket.readyState])); /** @todo how we can resolve this issue? */
    }

    const data = _objectSpread({
      type: method
    }, payload);
    socket.send(JSON.stringify(data));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
  }
};
exports.socketSend = socketSend;
socketSend.propTypes = {
  method: _propTypes.default.string.isRequired,
  socket: _Types.SocketType.isRequired,
  payload: _propTypes.default.shape({})
};
const socketMessage = _ref2 => {
  let {
    socket,
    cb
  } = _ref2;
  try {
    if (!socket) throw new Error('Socket is not exist');
    // eslint-disable-next-line no-param-reassign
    socket.onmessage = event => {
      cb(event);
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
  }
};
exports.socketMessage = socketMessage;
socketMessage.propTypes = {
  socket: _Types.SocketType.isRequired,
  cb: _propTypes.default.func.isRequired
};
const socketEmitter = _ref3 => {
  let {
    method,
    payload,
    socket
  } = _ref3;
  return (0, _reduxSaga.eventChannel)(emitter => {
    socketSend({
      method,
      socket,
      payload
    });
    socketMessage({
      socket,
      cb: resp => emitter(resp)
    });
    return () => socket.close();
  });
};
exports.socketEmitter = socketEmitter;
socketEmitter.propTypes = {
  method: _propTypes.default.string.isRequired,
  socket: _Types.SocketType.isRequired,
  payload: _propTypes.default.shape({})
};